// extracted by mini-css-extract-plugin
export default {"button":"Base_button__4o1Tj","disabled":"Base_disabled__6l60K"};